<div class="form-container" id="enquete-form" appearance="outlined" data-tfa="creer_objet-maquette">
    <mat-card-title>
        <h2>Descripteurs pour enquêtes</h2>
    </mat-card-title>
    <mat-card-content class="card-content">
        <ng-container [formGroup]="form.asFormGroup">
            <div formGroupName="descripteursSise" id="descripteurs-sise-container">
                <div class="form-field-group">
                    @if (form) {
                    <app-select-nomenclature
                        formControlName="typeDiplome"
                        [formFieldStyles]="{ 'width': '100%' }"
                        label="Type de diplôme"
                        [nomenclature]="NomenclatureType.TypeDiplome"
                        [contexteConsommation]="espace()"
                        [getFullValueFn]="getCodeEtLibelleLong"
                        data-tfa="enquete-form_input-type-diplome"
                    ></app-select-nomenclature>
                    } @if (form.typeDiplomeNomenclaturesImbriquees$ | async; as cursus) {
                    <div>
                        <mat-form-field>
                            <mat-label>Cursus</mat-label>
                            <input matInput type="text" data-tfa="input-cursus" formControlName="cursus" />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Niveau de formation</mat-label>
                            <input matInput type="text" data-tfa="input-niveau-formation" formControlName="niveauFormation" />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Nature de diplôme</mat-label>
                            <input matInput type="text" data-tfa="input-natureDiplome" formControlName="natureDiplome" />
                        </mat-form-field>
                    </div>
                    }
                </div>
                <div class="form-field-group">
                    @if (form) {
                    <app-select-nomenclature
                        [formFieldStyles]="{ 'width': '100%' }"
                        formControlName="niveauDiplome"
                        label="Niveau de diplôme"
                        [nomenclature]="NomenclatureType.NiveauDiplome"
                        [isParametrage]="true"
                        [contexteConsommation]="espace()"
                        [getFullValueFn]="getCodeEtLibelleLong"
                        data-tfa="enquete-form_input-niveau-diplome"
                    ></app-select-nomenclature>
                    }
                </div>
                <div class="form-field-group">
                    @if (form) {
                    <div formArrayName="domainesFormation" class="domaines-formation">
                        @if (form.domainesFormationSelectionnes$ | async; as domainesSelectionnes) { @for (control of
                        form.domainesFormationArray.controls; track control; let i = $index) {
                        <div class="domaine-formation">
                            <app-select-nomenclature
                                [formFieldStyles]="{ 'width': '100%' }"
                                [formControlName]="i"
                                [label]="'Domaine ' + (i + 1)"
                                [nomenclature]="NomenclatureType.DomaineFormation"
                                [contexteConsommation]="espace()"
                                [excludedValues]="domainesSelectionnes"
                                [showResetButton]="false"
                                [getFullValueFn]="getCodeEtLibelleLong"
                                [attr.data-tfa]="'enquete-form_input-domaine-' + i"
                            ></app-select-nomenclature>
                            @if (form.domainesFormationArray.length > 1 || control.value) {
                            <button
                                type="button"
                                mat-icon-button
                                color="accent"
                                [attr.data-tfa]="'enquete-form_remove-domaine-' + i"
                                aria-label="Supprimer ce domaine"
                                matTooltip="Supprimer ce domaine"
                                (click)="form.removeDomaineFormation(i)"
                            >
                                <mat-icon data-tfa="icon-delete">delete</mat-icon>
                            </button>
                            }
                        </div>
                        } } @if (form.domainesFormationArray.hasError('duplicateDomainesFormation')) {
                        <mat-error data-tfa="enquete-form_error-domaines-doublon"
                            >Un même domaine ne peut être saisi qu'une fois.</mat-error
                        >
                        } @if ((peutAjouterDomaineFormation$ | async) && form.domainesFormationArray.length < form.maxDomainesFormation) {
                        <button
                            type="button"
                            mat-raised-button
                            color="accent"
                            data-tfa="enquete-form_add-domaine"
                            [disabled]="!form.canAddDomaineFormation"
                            (click)="form.addDomaineFormation()"
                        >
                            <mat-icon data-tfa="icon-ajouter">add</mat-icon>
                            Ajouter un domaine
                        </button>
                        }
                        <span class="domaines-formation-count"
                            >{{ form.domainesFormationArray.length }}/{{ form.maxDomainesFormation }} domaines maximum</span
                        >
                    </div>
                    }
                </div>
                <div class="form-field-group">
                    @if (form) {
                    <app-select-nomenclature
                        [formFieldStyles]="{ 'width': '100%' }"
                        formControlName="mention"
                        label="Mention"
                        [nomenclature]="NomenclatureType.MentionDiplome"
                        [contexteConsommation]="espace()"
                        [getFullValueFn]="getCodeEtLibelleLong"
                        data-tfa="enquete-form_input-mention"
                    ></app-select-nomenclature>
                    }
                </div>
                <div class="form-field-group-tooltip">
                    <mat-form-field>
                        <mat-label>Numéro FRESQ de 1er niveau</mat-label>
                        <input
                            data-tfa="input_fresqu_niveau1"
                            matInput
                            #fresq1
                            type="text"
                            [formControl]="form.numeroFresqNiveau1Control"
                            placeholder="Ex: 2412345A"
                        />
                        <mat-hint>{{ fresq1.value.length }}/8</mat-hint>
                        <mat-error *appFormMatErrors="form.numeroFresqNiveau1Control"></mat-error>
                    </mat-form-field>
                    <button
                        mat-icon-button
                        (click)="tooltip.toggle()"
                        #tooltip="matTooltip"
                        data-tfa="tooltip_input_fresqu_niveau1"
                        matTooltip="numéro d'immatriculation national FRESQ du diplome visé à l'issue de la formation (niveau mention du diplome)"
                    >
                        <mat-icon data-tfa="icon_info_tooltip">info</mat-icon>
                    </button>
                </div>
                <div class="form-field-group-tooltip">
                    <mat-form-field>
                        <mat-label>Numéro FRESQ de 2nd niveau</mat-label>
                        <input
                            data-tfa="input_fresqu_niveau2"
                            matInput
                            #fresq2
                            type="text"
                            [formControl]="form.numeroFresqNiveau2Control"
                            placeholder="Ex: 2412345-123A"
                            matTooltip=""
                        />
                        <mat-hint>{{ fresq2.value.length }}/12</mat-hint>
                        <mat-error *appFormMatErrors="form.numeroFresqNiveau2Control"></mat-error>
                    </mat-form-field>
                    <button
                        mat-icon-button
                        (click)="tooltip.toggle()"
                        #tooltip="matTooltip"
                        data-tfa="tooltip_input_fresqu_niveau2"
                        matTooltip="numéro d'immatriculation national FRESQ de la déclinaison du diplome visé à l'issue de la formation (parcours , spécialité, spécialisation)"
                    >
                        <mat-icon data-tfa="icon_info_tooltip">info</mat-icon>
                    </button>
                </div>
                <div class="form-field-group-tooltip">
                    <mat-form-field>
                        <mat-label>Déclinaison du diplôme</mat-label>
                        <input
                            data-tfa="input_declinaison_diplome_descripteurs_sise"
                            matInput
                            type="text"
                            formControlName="declinaisonDiplome"
                            placeholder="Déclinaison du diplôme"
                        />
                        <mat-error *appFormMatErrors="form.asDescripteursSiseFormGroup.controls.declinaisonDiplome"></mat-error>
                    </mat-form-field>
                    <button
                        mat-icon-button
                        (click)="tooltip.toggle()"
                        #tooltip="matTooltip"
                        data-tfa="tooltip_declinaison_diplome_descripteurs_sise"
                        matTooltip="La déclinaison précise le parcours, la spécialité, la spécialisation&#13;choisie par l’apprenant au cours de son cursus, et qui sera précisée sur le diplôme."
                    >
                        <mat-icon data-tfa="icon_info_tooltip">info</mat-icon>
                    </button>
                </div>
                <div class="form-field-group">
                    @if (form) {
                    <app-select-nomenclature
                        [formFieldStyles]="{ 'width': '100%' }"
                        formControlName="champFormation"
                        label="Champ"
                        [isParametrage]="true"
                        [nomenclature]="NomenclatureType.ChampsFormation"
                        [contexteConsommation]="espace()"
                        [getFullValueFn]="getCodeEtLibelleLong"
                        data-tfa="enquete-form_input-champ-formation"
                    ></app-select-nomenclature>
                    }
                </div>
                <div class="form-field-group">
                    @if (form) {
                    <app-select-nomenclature
                        [formFieldStyles]="{ 'width': '100%' }"
                        formControlName="codeDiplomeSise"
                        label="Code diplôme SISE"
                        [nomenclature]="NomenclatureType.DiplomeSise"
                        [contexteConsommation]="espace()"
                        data-tfa="enquete-form_input-code-diplome-sise"
                    ></app-select-nomenclature>
                    }
                </div>
                <div class="form-field-group">
                    @if (form) {
                    <app-select-nomenclature
                        [formFieldStyles]="{ 'width': '100%' }"
                        formControlName="codeDiplomeIntermediaireSise"
                        label="Code diplôme intermédiaire SISE"
                        [nomenclature]="NomenclatureType.DiplomeSise"
                        [contexteConsommation]="espace()"
                        data-tfa="enquete-form_input-code-diplome-intermediaire-sise"
                    ></app-select-nomenclature>
                    }
                </div>
                <!-- </div> -->

                <div class="form-field-group">
                    <mat-form-field>
                        <mat-label>Niveau SISE dans le diplôme</mat-label>
                        <input
                            data-tfa="input_niveau_diplome_descripteurs_sise"
                            matInput
                            type="sring"
                            type="text"
                            inputmode="numeric"
                            formControlName="niveauDiplomeSise"
                            placeholder="Niveau SISE dans le Diplôme"
                        />
                        <mat-error *appFormMatErrors="form.asDescripteursSiseFormGroup.controls.niveauDiplomeSise"></mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    @if (form) {
                    <app-select-nomenclature
                        [formFieldStyles]="{ 'width': '100%' }"
                        formControlName="parcoursTypeSise"
                        label="Parcours type SISE"
                        [nomenclature]="NomenclatureType.ParcoursTypeSise"
                        [contexteConsommation]="espace()"
                        data-tfa="enquete-form_input-parcours-type"
                    ></app-select-nomenclature>
                    }
                </div>
                <div class="form-field-group">
                    <mat-form-field>
                        <mat-label>Code langue SISE</mat-label>
                        <input
                            matInput
                            type="text"
                            formControlName="codeLangueSise"
                            [matAutocomplete]="autoLangueSise"
                            data-tfa="enquete-form_input-code-langue-sise"
                        />
                        <mat-autocomplete #autoLangueSise="matAutocomplete" [displayWith]="affichageLangueSise">
                            @for (langueSise of languesSiseFiltrees(); track langueSise.code) {
                            <mat-option [value]="langueSise.code" [attr.data-tfa]="'code-langue-sise_option-' + langueSise.code"
                                >{{ langueSise.code }} - {{ langueSise.libelle }}</mat-option
                            >
                            }
                        </mat-autocomplete>
                        @if (form.codeLangueSiseControl.value && form.codeLangueSiseControl.enabled) {
                        <button
                            mat-icon-button
                            matSuffix
                            (click)="resetCodeLangueSise()"
                            aria-label="Supprimer la valeur saisie"
                            data-tfa="empty-input-button_code-langue-sise"
                        >
                            <mat-icon data-tfa="empty-input-icon_code-langue-sise">close</mat-icon>
                        </button>
                        } @if (form.codeLangueSiseControl.hasError('pattern')) {
                        <mat-error data-tfa="error_code-langue-sise">Le code langue SISE doit être composé de 4 chiffres</mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div formGroupName="descripteursAglae" id="descripteurs-aglae-container">
                <div class="form-field-group">
                    <mat-checkbox data-tfa="input_habilite_aglae" formControlName="habilitePourBoursesAglae"
                        >Habilité pour bourses aglaé</mat-checkbox
                    >
                    <mat-error *appFormMatErrors="form.asDescripteursAglaeFormGroup.controls.habilitePourBoursesAglae"></mat-error>
                </div>
                <div class="form-field-group">
                    <mat-form-field>
                        <mat-label>Niveau Aglaé dans le diplôme</mat-label>
                        <input
                            data-tfa="input_niveau_descripteurs_aglae"
                            matInput
                            type="text"
                            inputmode="numeric"
                            formControlName="niveauAglae"
                            placeholder="Niveau Aglaé"
                        />
                        <mat-error *appFormMatErrors="form.asDescripteursAglaeFormGroup.controls.niveauAglae"></mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="buttons-horizontal-container">
                <ng-content select="#bouton-fermer-objet-maquette"></ng-content>
                <button
                    data-tfa="objet-maquette-créer-button"
                    [disabled]="form.asFormGroup.invalid || form.asFormGroup.pristine"
                    mat-raised-button
                    color="primary"
                    (click)="modifierDescripteursEnquete()"
                >
                    <mat-icon data-tfa="icone-valider">check</mat-icon>
                    Enregistrer
                </button>
            </div>
        </ng-container>
    </mat-card-content>
</div>
